export const AiActionTypes = {
  TOGGLE_AI: 'TOGGLE_AI',
  GET_CONVERSATION_LIST: 'GET_CONVERSATION_LIST',
  UPDATE_FEEBACK_ITEM: 'UPDATE_FEEBACK_ITEM',
  CLEAR_CONVERSATION_LIST: 'CLEAR_CONVERSATION_LIST',
} as const;

interface ConversationItem {
  feedback: any;
  log_id: string;
  id: string;
  type: 'query' | 'general' | 'explaination' | 'response' | 'data_table' | string;
  msg: string | Record<string, unknown>;
}

// Interface for the GET_CONVERSATION_LIST action
export interface GetConversationListAction {
  type: typeof AiActionTypes.GET_CONVERSATION_LIST; // Use the renamed constant here
  payload: ConversationItem[];
}

export const openAiscreen = (payload: boolean) => ({
  type: AiActionTypes.TOGGLE_AI, // Use the renamed constant here
  payload,
});

export const getConversationAction = (payload: ConversationItem[]): GetConversationListAction => ({
  type: AiActionTypes.GET_CONVERSATION_LIST, // Use the renamed constant here
  payload,
});

export const updateFeedbackAction = (payload: ConversationItem[]) => ({
  type: AiActionTypes.UPDATE_FEEBACK_ITEM, // Use the renamed constant here
  payload,
});

export const clearConversationList = () => ({
  type: AiActionTypes.CLEAR_CONVERSATION_LIST,
});

export const aiActionTypes = {
  openAiscreen,
  getConversationAction,
  updateFeedbackAction,
  clearConversationList,
};
